import { UserFormRow } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const WrapperTeamForm = styled.form``;

const teamFormSectionStyles = css`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin: 36px 0 0;
  max-width: 100%;
  &:first-of-type {
    margin-top: 3px;
  }
`;

export const RightSide = styled.div`
  display: flex;
  > *:first-child {
    margin-right: 20px;
  }
`;
export const TeamFormSection = styled.div`
  ${teamFormSectionStyles};
  ${UserFormRow} {
    margin-top: 30px;
    align-items: flex-start;
  }
`;
